export const PARAM_NAMES = {
    hourlyFactor: 'Hourly Factor',
    dailyFactor: 'Daily Factor'
};


// WEBPACK FOOTER //
// ./src/scenes/BidderWinRateConfig/config.js